import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    classify: false
  },
  mutations:{
    set_false(state) {
      console.log(state.classify)
      state.classify = false;
    },
    set_true(state) {
      // console.log(state)
      console.log(state.classify)

      state.classify = true;
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js